
import axios from 'axios';

import { getAuthToken } from '../utils/authUtils'; //

const API_BASE = process.env.REACT_APP_FIREBASE_BACKEND_API_BASE || 'https://quantumleap-emr-dev.web.app';
export const workingHoursService = {
  /**
   * Get working hours for a user at a specific facility
   * @param {string} userId - The user ID
   * @param {string} facilityId - The facility ID
   * @param {Date} startDate - Start date for the range
   * @param {Date} endDate - End date for the range
   * @returns {Promise<Array>} Array of working hours
   */
  async getWorkingHours(userId, facilityId, startDate, endDate) {
    try {
      const token = await getAuthToken();
      
      const params = new URLSearchParams();
      params.append('userId', userId);
      params.append('facilityId', facilityId);
      params.append('startDate', startDate.toISOString());
      params.append('endDate', endDate.toISOString());

      const response = await axios.get(`${API_BASE}/working-hours`, {
        params,
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      return response.data.workingHours || [];
    } catch (error) {
      console.error('Error fetching working hours:', error);
      return [];
    }
  },

  /**
   * Update working hours with overtime information
   * @param {string} workingHoursId - The working hours document ID
   * @param {Object} updateData - Data to update
   * @returns {Promise<Object>} Update result
   */
  async updateWorkingHours(workingHoursId, updateData) {
    try {
      const token = await getAuthToken();
      
      const response = await axios.put(`${API_BASE}/working-hours/${workingHoursId}`, updateData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      return response.data;
    } catch (error) {
      console.error('Error updating working hours:', error);
      throw error;
    }
  },

  /**
   * Get today's working hours for a user at a facility
   * @param {string} userId - The user ID
   * @param {string} facilityId - The facility ID
   * @returns {Promise<Object|null>} Today's working hours or null
   */
  async getTodayWorkingHours(userId, facilityId) {
    try {
      const today = new Date();
      const startOfDay = new Date(today);
      startOfDay.setHours(0, 0, 0, 0);
      
      const endOfDay = new Date(today);
      endOfDay.setHours(23, 59, 59, 999);

      const workingHours = await this.getWorkingHours(userId, facilityId, startOfDay, endOfDay);
      return workingHours.length > 0 ? workingHours[0] : null;
    } catch (error) {
      console.error('Error fetching today working hours:', error);
      return null;
    }
  }
};
